import { css, cx } from '@linaria/core'

export const navCss = css`
  width: 100%;
  padding: 6px 10px;
  background: white;
`

// The `fixedMaxWidth` prop was deprecated as of v6.6.0
export const fixedMaxWidthCss = css`
  max-width: 1440px;
  margin-inline-start: auto;
  margin-inline-end: auto;
`

export const listCss = css`
  display: flex;
  align-items: center;
  list-style: none;
  gap: 2px;
  // Need to position so the list items can reference the correct offsetParent in resize callback:
  position: relative;
`

// Added while the list is recalculating. Used for combinators with other classes.
// TODO: Our typical pattern for what this class doing has been to use attribute selectors
export const listCalculatingCss = css``

export const visibleListItemCss = css`
  display: flex;
  align-items: center;
  white-space: nowrap;
  padding: 0;
  margin: 0;
`

export const groupsNavListItemCss = css`
  margin: 0;
  margin-inline-end: 0.5rem;
  max-width: 200px;
`

export const moreListItemCss = css`
  margin: 0;

  .${listCalculatingCss} & {
    visibility: hidden;
  }
`

export const visuallyHiddenCss = css`
  ul:not(.${listCalculatingCss}) & {
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }

  .${listCalculatingCss} & {
    visibility: hidden;
  }
`

// Pushes these list items to the end by applying auto margin to the first one
export const endCss = css`
  &:not(& ~ &) {
    margin-inline-start: auto;
  }
`

export const linkCss = css`
  display: inline-flex;
  gap: 0.125rem;
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 4px;
  cursor: pointer;
  font: inherit;
  line-height: inherit;
  padding: 4px 10px;
  margin: 0;
  text-decoration: none;
  white-space: nowrap;
  font-size: 14px;
`

export const visibleLinkCss = cx(
  linkCss,
  css`
    &:hover,
    &[aria-current='page'] {
      background: #e1edc1;
    }

    &,
    &:visited,
    &:active,
    &:hover {
      color: #666662;
    }
  `
)

export const buttonCss = cx(
  visibleLinkCss,
  css`
    &:focus-visible {
      /** Same as Link's */
      outline: solid currentcolor;
      outline-width: 3px;
      outline-offset: 3px;
      border-radius: 2px;
    }
  `
)
